import { http } from '@/api/http';

const SEND_PATH = '/system/public/send_reset_password_code';
const VERIFY_PATH = '/system/public/virify_reset_password_code';

export interface SendResetPasswordCodeResponse {
  error?: boolean;
  message?: string;
}

export interface VerifyResetPasswordCodeResponse {
  error?: boolean;
  message?: string;
}

export async function postSendResetPasswordCode(email: string): Promise<void> {
  await http.post<SendResetPasswordCodeResponse>(SEND_PATH, { email: email.trim() });
}

export async function postVerifyResetPasswordCode(body: {
  email: string;
  verification_code: string;
  new_password: string;
}): Promise<void> {
  await http.post<VerifyResetPasswordCodeResponse>(VERIFY_PATH, {
    email: body.email.trim(),
    verification_code: body.verification_code.trim(),
    new_password: body.new_password,
  }, { showSuccessModal: true });
}
